module.exports = __webpack_public_path__ + "static/media/office.ee44d615.jpg";